import { render, staticRenderFns } from "./EvaluacionesAnualesTable.vue?vue&type=template&id=06aa0c6a"
import script from "./EvaluacionesAnualesTable.vue?vue&type=script&lang=js"
export * from "./EvaluacionesAnualesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports